import slideEducation from '@/assets/images/group-3137670_1280.jpg'
import slideEntrepreneurship from '@/assets/images/IBON-World-Launch-14.jpeg'
import slideCulture from '@/assets/images/IBON-World-Launch-27.jpeg'
import type { HeroSlide } from '@/types/hero'

export const SLIDE_INTERVAL = 5500

export const slides: HeroSlide[] = [
  { src: slideEducation, alt: 'Students supported by IBON World across Africa and the Caribbean' },
  { src: slideEntrepreneurship, alt: 'Young entrepreneurs networking at an IBON World event' },
  { src: slideCulture, alt: 'Cultural performance at the IBON World culture festival in Accra' },
]
